<h2 mat-dialog-title>
  @if (data.name) {
    <span
      innerHTML="Edit Item {{ data.name }} in {{ data.categoryName }}"
    ></span>
  } @else {
    <span innerHTML="Add New Item to {{ data.categoryName }}"> </span>
  }
</h2>

<mat-dialog-content>
  <form #frm="ngForm">
    <div class="section basic-section">
      <h3 class="section-title">Basic Info</h3>

      <div class="basic-fields">
        <div class="input-group">
          <label for="item-name">Item Name</label>
          <input
            id="item-name"
            name="name"
            type="text"
            [(ngModel)]="data.name"
            required
            placeholder="e.g. Cod"
            />
        </div>

        <div class="input-group">
          <label for="item-desc">Description</label>
          <textarea
            id="item-desc"
            name="description"
            rows="2"
            [(ngModel)]="data.description"
            placeholder="Short description…"
          ></textarea>
        </div>

        <div class="basic-fields-row">
          <div class="input-group compact-field">
            <label for="item-price">Base Price (£)</label>
            <input
              id="item-price"
              name="price"
              type="number"
              min="0"
              step="0.01"
              [(ngModel)]="data.price"
              placeholder="0.00"
              />
            <small class="muted">Base price includes VAT.</small>
          </div>

          <div class="input-group compact-field">
            <label for="item-vat-rate">VAT Rate (%)</label>

            <mat-form-field
              appearance="outline"
              class="vat-select-field custom-select-match"
              >
              <mat-select
                id="item-vat-rate"
                name="vatRate"
                [(ngModel)]="data.vatRate"
                panelClass="waitron-select-panel"
                >
                @for (rate of vatRateOptions; track rate) {
                  <mat-option [value]="rate">
                    {{ rate }}%
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <small class="muted">Rate included in base price.</small>
          </div>
        </div>
      </div>
    </div>

    <div class="section groups-section">
      <h3 class="section-title">Attach Option Groups</h3>

      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Select groups</mat-label>

        <mat-select
          [(ngModel)]="selectedGroupIds"
          name="selectedGroups"
          multiple
          panelClass="waitron-select-panel"
          >
          @for (g of availableGroups; track g) {
            <mat-option [value]="g.optionId">
              {{ g.groupName }}
            </mat-option>
          }
        </mat-select>

        <mat-hint
          >Choose one or more existing groups (e.g. Sauces,
          Condiments)</mat-hint
          >
        </mat-form-field>

        @if (selectedGroupsPreview.length) {
          <div class="selected-groups-preview">
            <h4 style="margin: 12px 0 6px">Selected groups</h4>
            @for (group of selectedGroupsPreview; track group) {
              <div
                class="selected-group-pill"
                >
                {{ group.groupName }}
              </div>
            }
          </div>
        }

        @if (selectedGroupsPreview.length) {
          <div class="attached-preview">
            <h4 style="margin: 12px 0 6px">Selected group details</h4>
            @for (g of selectedGroupsPreview; track g) {
              <div class="attached-group">
                <div class="attached-title">
                  <strong>{{ g.groupName }}</strong>
                  @if (g.extras?.length) {
                    <span class="muted">
                      ({{ g.extras?.length }} options)
                    </span>
                  }
                </div>
                @if (g.extras?.length) {
                  <ul class="attached-extras">
                    @for (ex of g.extras; track ex) {
                      <li>
                        {{ ex.extraName }}
                        @if (ex.extraPrice) {
                          <span>
                            (+{{ ex.extraPrice | currency: "GBP" : "symbol" : "1.2-2" }})
                          </span>
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  <div class="muted">No extras in this group.</div>
                }
              </div>
            }
          </div>
        }
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </mat-dialog-actions>
